const SCOPE = [
  'https://www.googleapis.com/auth/classroom.courses.readonly',
  'https://www.googleapis.com/auth/classroom.rosters.readonly',
  'https://www.googleapis.com/auth/classroom.profile.emails',
  'https://www.googleapis.com/auth/classroom.profile.photos',
];

export function authenticateClassroom(clientId, success, error) {
  window.gapi.auth.authorize(
    {
      client_id: clientId,
      scope: SCOPE,
      immediate: false,
    },
    handleAuthResult
  );

  function handleAuthResult(authResult) {
    if (authResult && !authResult.error) {
      // No fijamos API Key: la petición ya va autenticada con el token OAuth, que identifica
      // el proyecto de Google Cloud. Fijar una API Key de un proyecto distinto al del OAuth client
      // provoca "The API Key and the authentication credential are from different projects"
      // (400 CONSUMER_INVALID) en los orígenes cuyo client OAuth vive en otro proyecto (TAN-8781).
      return window.gapi.client.load('https://classroom.googleapis.com/$discovery/rest?version=v1').then(
        function () {
          success();
        },
        function (err) {
          error(err);
        }
      );
    }
    // El usuario denegó el acceso o cerró el popup de Google: propagamos el error para no
    // dejar el diálogo colgado en estado de carga.
    error(authResult);
  }
}

export function getClassrooms(success, error) {
  window.gapi.client.classroom.courses.list().then(
    function (response) {
      success(response);
    },
    function (err) {
      error(err);
    }
  );
}

export function getClassroomStudents(guid, success, error) {
  let allStudents = []; // Almacena todos los estudiantes
  let pageSize = 40; // Ajusta el tamaño de página, puedes cambiarlo si necesitas menos/más estudiantes

  function fetchStudents(pageToken) {
    // Hacer la solicitud con el token de página (si es la primera página, no hay token)
    window.gapi.client.classroom.courses.students
      .list({
        courseId: guid,
        pageSize: pageSize,
        pageToken: pageToken, // Puede ser undefined o el token de la siguiente página
      })
      .then(
        function (response) {
          // Agregar los estudiantes obtenidos a la lista total
          if (response.result.students) {
            allStudents = allStudents.concat(response.result.students);
          }

          // Si hay más páginas, continuar la paginación
          if (response.result.nextPageToken) {
            fetchStudents(response.result.nextPageToken); // Recursivo, busca la siguiente página
          } else {
            // Si ya no hay más páginas, llama al callback de éxito con todos los estudiantes
            success(guid, { students: allStudents });
          }
        },
        function (err) {
          // Llama al callback de error en caso de fallo
          error(err);
        }
      );
  }

  // Inicia la primera solicitud sin token de página
  fetchStudents();
}
